import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function LotSelectModal({ title, onClose, status, handleLotClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    item_lotno: true,
    item_lotno_status: false,
    item_lotno_status_name: false,
    item_lot_create_type: false,
    item_lot_create_type_name: false,
    item_lot_delete_type: false,
    item_lot_delete_type_name: false,
    item_id: false,
    item_version_seq: false,
    item_name: true,
    item_spec: false,
    item_width: false,
    item_depth: false,
    item_height: false,
    item_full_spec: true,
    item_type: false,
    item_type_name: false,
    item_division: false,
    item_division_name: false,
    item_lot_c_produce_work_id: false,
    item_lot_c_incoming_id: false,
    item_lot_c_stock_adjustment_id: false,
    item_lot_c_quality_id: false,
    item_lot_d_produce_work_id: false,
    item_lot_d_outgoing_id: false,
    item_lot_d_stock_adjustment_id: false,
    item_lot_d_quality_discard_id: false,
    item_lot_d_discard_id: false,
    item_lot_l_loss_id: false,
    item_lot_p_produce_work_id: false,
    item_lot_save_workplace_id: false,
    item_lot_save_warehouse_id: false,
    item_lot_save_section_id: false,
    item_lot_save_workplace_name: false,
    item_lot_save_warehouse_name: false,
    item_lot_save_section_name: false,
    item_lot_full_save_name: true,
    item_lot_create_expiration_date: false,
    item_lot_delete_expiration_date: false,
    item_lot_create_datetime: false,
    item_lot_delete_datetime: false,
    item_lot_loss_datetime: false,
    item_lot_plan_datetime: false,
    item_lot_stock_datetime: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    searchRef.current.focus();
    handleSetting();
    handleView();
    setColumnVisibilityModel({
      id: false,
      item_lotno: true,
      item_lotno_status: false,
      item_lotno_status_name: false,
      item_lot_create_type: false,
      item_lot_create_type_name: false,
      item_lot_delete_type: false,
      item_lot_delete_type_name: false,
      item_id: false,
      item_version_seq: false,
      item_name: true,
      item_spec: false,
      item_width: false,
      item_depth: false,
      item_height: false,
      item_full_spec: true,
      item_type: false,
      item_type_name: false,
      item_division: false,
      item_division_name: false,
      item_lot_c_produce_work_id: false,
      item_lot_c_incoming_id: false,
      item_lot_c_stock_adjustment_id: false,
      item_lot_c_quality_id: false,
      item_lot_d_produce_work_id: false,
      item_lot_d_outgoing_id: false,
      item_lot_d_stock_adjustment_id: false,
      item_lot_d_quality_discard_id: false,
      item_lot_d_discard_id: false,
      item_lot_l_loss_id: false,
      item_lot_p_produce_work_id: false,
      item_lot_save_workplace_id: false,
      item_lot_save_warehouse_id: false,
      item_lot_save_section_id: false,
      item_lot_save_workplace_name: false,
      item_lot_save_warehouse_name: false,
      item_lot_save_section_name: false,
      item_lot_full_save_name: true,
      item_lot_create_expiration_date: false,
      item_lot_delete_expiration_date: false,
      item_lot_create_datetime: false,
      item_lot_delete_datetime: false,
      item_lot_loss_datetime: false,
      item_lot_plan_datetime: false,
      item_lot_stock_datetime: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'item_lotno', headerName: 'LotNo', width: 160, headerAlign: 'center', align:'center' },
      { field: 'item_lotno_status', headerName: 'item_lotno_status', width: 0, headerAlign: 'center' },
      { field: 'item_lotno_status_name', headerName: 'item_lotno_status_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_create_type', headerName: 'item_lot_create_type', width: 0, headerAlign: 'center' },
      { field: 'item_lot_create_type_name', headerName: 'item_lot_create_type_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_delete_type', headerName: 'item_lot_delete_type', width: 0, headerAlign: 'center' },
      { field: 'item_lot_delete_type_name', headerName: 'item_lot_delete_type_name', width: 0, headerAlign: 'center' },
      { field: 'item_id', headerName: 'item_id', width: 0, headerAlign: 'center' },
      { field: 'item_version_seq', headerName: 'item_version_seq', width: 0, headerAlign: 'center' },
      { field: 'item_name', headerName: '품목', width: 120, headerAlign: 'center' },
      { field: 'item_full_spec', headerName: '규격', width: 180, headerAlign: 'center' },
      { field: 'item_spec', headerName: '규격', width: 150, headerAlign: 'center' },
      { field: 'item_width', headerName: '가로', width: 90, headerAlign: 'center', align:'right' },
      { field: 'item_depth', headerName: '세로', width: 90, headerAlign: 'center', align:'right' },
      { field: 'item_height', headerName: '높이', width: 90, headerAlign: 'center', align:'right' },
      { field: 'item_type', headerName: 'item_type', width: 0, headerAlign: 'center' },
      { field: 'item_type_name', headerName: 'item_type_name', width: 0, headerAlign: 'center' },
      { field: 'item_division', headerName: 'item_division', width: 0, headerAlign: 'center' },
      { field: 'item_division_name', headerName: 'item_division_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_c_produce_work_id', headerName: 'item_lot_c_produce_work_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_c_incoming_id', headerName: 'item_lot_c_incoming_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_c_stock_adjustment_id', headerName: 'item_lot_c_stock_adjustment_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_c_quality_id', headerName: 'item_lot_c_quality_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_d_produce_work_id', headerName: 'item_lot_d_produce_work_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_d_outgoing_id', headerName: 'item_lot_d_outgoing_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_d_stock_adjustment_id', headerName: 'item_lot_d_stock_adjustment_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_d_quality_discard_id', headerName: 'item_lot_d_quality_discard_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_d_discard_id', headerName: 'item_lot_d_discard_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_l_loss_id', headerName: 'item_lot_l_loss_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_p_produce_work_id', headerName: 'item_lot_p_produce_work_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_workplace_id', headerName: 'item_lot_save_workplace_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_warehouse_id', headerName: 'item_lot_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_section_id', headerName: 'item_lot_save_section_id', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_workplace_name', headerName: 'item_lot_save_workplace_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_warehouse_name', headerName: 'item_lot_save_warehouse_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_save_section_name', headerName: 'item_lot_save_section_name', width: 0, headerAlign: 'center' },
      { field: 'item_lot_full_save_name', headerName: '보관장소', width: 200, headerAlign: 'center' },
      { field: 'item_lot_create_expiration_date', headerName: 'item_lot_create_expiration_date', width: 0, headerAlign: 'center' },
      { field: 'item_lot_delete_expiration_date', headerName: 'item_lot_delete_expiration_date', width: 0, headerAlign: 'center' },
      { field: 'item_lot_create_datetime', headerName: 'item_lot_create_datetime', width: 0, headerAlign: 'center' },
      { field: 'item_lot_delete_datetime', headerName: 'item_lot_delete_datetime', width: 0, headerAlign: 'center' },
      { field: 'item_lot_loss_datetime', headerName: 'item_lot_loss_datetime', width: 0, headerAlign: 'center' },
      { field: 'item_lot_plan_datetime', headerName: 'item_lot_plan_datetime', width: 0, headerAlign: 'center' },
      { field: 'item_lot_stock_datetime', headerName: 'item_lot_stock_datetime', width: 0, headerAlign: 'center' }
    ]);
  }

  const handleView = () => {
    setRows([]);
    axios.get('/api/SelectCommon/LotList',
        {
        params : {
          keyword: keyword,
          status: status
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
      var array = response.data.map((item, index) => ({
        id: index,
        item_lotno: item.item_lotno,
        item_lotno_status: item.item_lotno_status,
        item_lotno_status_name: item.item_lotno_status_name,
        item_lot_create_type: item.item_lot_create_type,
        item_lot_create_type_name: item.item_lot_create_type_name,
        item_lot_delete_type: item.item_lot_delete_type,
        item_lot_delete_type_name: item.item_lot_delete_type_name,
        item_id: item.item_id,
        item_version_seq: item.item_version_seq,
        item_name: item.item_name,
        item_full_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
        item_spec: item.item_spec,
        item_width: item.item_width,
        item_depth: item.item_depth,
        item_height: item.item_height,
        item_type: item.item_type,
        item_type_name: item.item_type_name,
        item_division: item.item_division,
        item_division_name: item.item_division_name,
        item_lot_c_produce_work_id: item.item_lot_c_produce_work_id,
        item_lot_c_incoming_id: item.item_lot_c_incoming_id,
        item_lot_c_stock_adjustment_id: item.item_lot_c_stock_adjustment_id,
        item_lot_c_quality_id: item.item_lot_c_quality_id,
        item_lot_d_produce_work_id: item.item_lot_d_produce_work_id,
        item_lot_d_outgoing_id: item.item_lot_d_outgoing_id,
        item_lot_d_stock_adjustment_id: item.item_lot_d_stock_adjustment_id,
        item_lot_d_quality_discard_id: item.item_lot_d_quality_discard_id,
        item_lot_d_discard_id: item.item_lot_d_discard_id,
        item_lot_l_loss_id: item.item_lot_l_loss_id,
        item_lot_p_produce_work_id: item.item_lot_p_produce_work_id,
        item_lot_save_workplace_id: item.item_lot_save_workplace_id,
        item_lot_save_warehouse_id: item.item_lot_save_warehouse_id,
        item_lot_save_section_id: item.item_lot_save_section_id,
        item_lot_save_workplace_name: item.item_lot_save_workplace_name,
        item_lot_save_warehouse_name: item.item_lot_save_warehouse_name,
        item_lot_save_section_name: item.item_lot_save_section_name,
        item_lot_full_save_name: item.item_lot_save_workplace_name + ' ' + item.item_lot_save_warehouse_name + ' ' + item.item_lot_save_section_name,
        item_lot_create_expiration_date: item.item_lot_create_expiration_date,
        item_lot_delete_expiration_date: item.item_lot_delete_expiration_date,
        item_lot_create_datetime: item.item_lot_create_datetime,
        item_lot_delete_datetime: item.item_lot_delete_datetime,
        item_lot_loss_datetime: item.item_lot_loss_datetime,
        item_lot_plan_datetime: item.item_lot_plan_datetime,
        item_lot_stock_datetime: item.item_lot_stock_datetime,
      }));
      setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handleLotClick 이벤트 만들어 놓아야함.
    handleLotClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleLotClick({
      id : '',
      item_lotno : '',
      item_lotno_status : '',
      item_lotno_status_name : '',
      item_lot_create_type : '',
      item_lot_create_type_name : '',
      item_lot_delete_type : '',
      item_lot_delete_type_name : '',
      item_id : '',
      item_version_seq : '',
      item_name : '',
      item_spec : '',
      item_width : '',
      item_depth : '',
      item_height : '',
      item_type : '',
      item_type_name : '',
      item_division : '',
      item_division_name : '',
      item_lot_c_produce_work_id : '',
      item_lot_c_incoming_id : '',
      item_lot_c_stock_adjustment_id : '',
      item_lot_c_quality_id : '',
      item_lot_d_produce_work_id : '',
      item_lot_d_outgoing_id : '',
      item_lot_d_stock_adjustment_id : '',
      item_lot_d_quality_discard_id : '',
      item_lot_d_discard_id : '',
      item_lot_l_loss_id : '',
      item_lot_p_produce_work_id : '',
      item_lot_save_workplace_id : '',
      item_lot_save_warehouse_id : '',
      item_lot_save_section_id : '',
      item_lot_save_workplace_name : '',
      item_lot_save_warehouse_name : '',
      item_lot_save_section_name : '',
      item_lot_create_expiration_date : '',
      item_lot_delete_expiration_date : '',
      item_lot_create_datetime : '',
      item_lot_delete_datetime : '',
      item_lot_loss_datetime : '',
      item_lot_plan_datetime : '',
      item_lot_stock_datetime : ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default LotSelectModal;